<div class="l-dialog__contents-custom" aria-modal="true">
  <div class="p-dialog">
    <p class="p-dialog__text">modal sample</p>
    <div class="p-dialog-btn p-dialog-btn--2btn">
      <button id="dialog_cancel-button" class="c-btn-secondary" (click)="handleCancelClick()">
        <span class="c-btn-secondary__text" [innerHTML]="'label.close2' | staticMsg"></span>
      </button>
      <button id="dialog_confirm-button" class="c-btn-primary" (click)="handleConfirmClick()">
        <span class="c-btn-primary__text" [innerHTML]="'label.confirm2' | staticMsg"></span>
      </button>
    </div>
  </div>
</div>
